import { Dealer } from '../dealers/dealers.model';
import { User } from '../authentication/auth.models';
import { Farmer, FarmerRegions } from '../farmers/farmers.model';
import { Product } from '../products/product.model';
import { DesignationEnum } from '../common/models/common.model';

export interface Employee {
  id: string;
  designation: Designation;
  user: User;
  dealers: Dealer[];
  created_at: string;
  updated_at: string;
  employee_number: string;
  date_of_joining: string | null;
}

export enum UserRole {
  ADMIN = 'admin',
  EMPLOYEE = 'employee',
}

export interface Session {
  checkIn: string;
  checkOut: string;
  left?: string;
  width?: string;
  checkInPercent?: string;
  checkOutPercent?: string;
}

export interface DayAttendance {
  date: string;
  sessions: Session[];
}

export type Designation = {
  id: string;
  created_at: string;
  updated_at: string;
  title: DesignationEnum;
};

export interface EmployeeBasicInfo {
  id: string;
  employee_number: string;
  first_name: string;
  last_name: string;
  full_name: string;
  profile_picture: string | null;
  user_id: string;
}

export interface EmployeeLocation {
  id: string;
  latitude: number;
  longitude: number;
  remaining_battery: number;
  network_strength: string;
  timestamp: string; // ISO date-time string
  address: string;
}

export interface EmployeeDetails extends Employee {
  farmers: Farmer[];
  products_promoted: Product[];
}

export enum SalesOfficersRole {
  SALES_OFFICERS = 'sales-officers',
  AREA_SALES_MANAGERS = 'area-sales-managers',
  REGIONAL_SALES_MANAGERS = 'regional-sales-managers',
}
